import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {EmptyResultComponent} from './empty-result.component';
import {TranslateModule} from '@core/pipes/translate/translate.module';
import {RouterModule} from '@angular/router';
import {ImagePathModule} from '@core/pipes/image-path/image-path.module';


@NgModule({
  declarations: [
    EmptyResultComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    RouterModule,
    ImagePathModule
  ],
  exports: [
    EmptyResultComponent
  ]
})
export class EmptyResultModule {
}
